<div class="user-image-wrapper">
  <img (inViewportAction)="$event.visible && (alreadyBeenInViewPort = true)"
       *ngIf="!successfullyLoaded && !hasLoadError && !!userPictureUrl"
       class="user-image" inViewport src="assets/images/fallback/driver_fallback_{{locale.currentLanguage}}.png">
  <img *ngIf="!userPictureUrl || hasLoadError"
       class="user-image" src="assets/images/fallback/driver_fallback_{{locale.currentLanguage}}.png">
  <img (error)="hasLoadError = true" (load)="successfullyLoaded = true"
       *ngIf="!!userPictureUrl && alreadyBeenInViewPort"
       [hidden]="!successfullyLoaded" [src]="userPictureUrl" class="user-image">
  <pw-centered-spinner *ngIf="showLoader && !successfullyLoaded && !hasLoadError && !!userPictureUrl"></pw-centered-spinner>
</div>
